import { Separator } from '@/components/ui/separator'

interface ContentSectionProps {
    title: string
    desc: string
    children: React.ReactNode
    fullWidth?: boolean
}

export function ContentSection({
    title,
    desc,
    children,
    fullWidth = false,
}: ContentSectionProps) {
    return (
        <div className='flex flex-1 flex-col'>
            <div className='flex-none'>
                <h3 className='text-lg font-medium'>{title}</h3>
                <p className='text-muted-foreground text-sm'>{desc}</p>
            </div>
            <Separator className='my-4 flex-none' />
            <div
                className={`-mx-4 flex-1 overflow-auto scroll-smooth px-4 md:pb-16 ${!fullWidth ? 'lg:max-w-xl' : 'w-full'
                    }`}
            >
                <div className={`${!fullWidth ? 'lg:max-w-xl' : 'w-full'}`}>{children}</div>
            </div>
        </div>
    )
}
